export const getSkillNotationNumber = (pointAcquired, totalPoint) => {
  if (totalPoint === 0) {
    return 0;
  }
  return Math.round((pointAcquired / totalPoint) * 50) / 10;
};
